import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "../App";

// As validades da ficha que vêm de um documento atual (aprovado, ou carregado pela DI).
// Esses campos aparecem só de leitura: o documento é a fonte, e o servidor também não os grava à mão.
export function useCamposDoDocumento(ownerKind, ownerId) {
  const [bloqueados, setBloqueados] = useState(new Set());

  useEffect(() => {
    if (!ownerId) {
      setBloqueados(new Set());
      return undefined;
    }
    let cancelado = false;
    axios.get(`${API}/di/documents/campos-do-documento/${ownerKind}/${ownerId}`, { withCredentials: true })
      .then((r) => { if (!cancelado) setBloqueados(new Set(r.data.bloqueados || [])); })
      .catch(() => { if (!cancelado) setBloqueados(new Set()); });
    return () => { cancelado = true; };
  }, [ownerKind, ownerId]);

  return bloqueados;
}

export const AVISO_DOCUMENTO = "Vem do documento carregado. Para mudar, carregue outro documento em Documentos anexos.";
